export default "__VITE_ASSET__BSiqncdt__"